import { render, staticRenderFns } from "./StudioMobileChat.vue?vue&type=template&id=686f9e96&"
import script from "./StudioMobileChat.vue?vue&type=script&lang=ts&"
export * from "./StudioMobileChat.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports